"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expandTilde = void 0;
const os_1 = require("os");
const path_1 = require("path");
function expandTilde(filepath) {
    const home = (0, os_1.homedir)();
    if (filepath.charCodeAt(0) === 126 /* ~ */) {
        if (filepath.charCodeAt(1) === 43 /* + */) {
            return (0, path_1.join)(process.cwd(), filepath.slice(2));
        }
        return home ? (0, path_1.join)(home, filepath.slice(1)) : filepath;
    }
    return filepath;
}
exports.expandTilde = expandTilde;
//# sourceMappingURL=expandTilde.js.map